import React, { FunctionComponent } from 'react';

/**
 * Root Component
 * Load all async request at app startup
 */
const RootComponent: FunctionComponent = (props) => {
  return <>{props.children}</>;
};

export default RootComponent;
